import React, { Fragment } from 'react';
import { useRemountKeyOnBfCache } from '../../../hooks';
/**
 * This component remounts its children when page is loaded via BfCache
 */
export const RemountOnBfCachedLoad = ({ children }) => {
    const { pageLoadNumber } = useRemountKeyOnBfCache();
    return React.createElement(Fragment, { key: pageLoadNumber }, children);
};
//# sourceMappingURL=index.js.map